module.exports = __webpack_public_path__ + "img/logo_white@2x.91f53abb.png";